import { DATABASE } from "../../../database";
import { DataBaseEnum } from "../../../database/enum";
import { INTERNAL_API_V2_GET } from "../base";

export async function API_V2_HOME_BANNERS_GET_BANNER_LIST(id_local) {
    const url = `homeBanners/getBannerList/?id_local=${id_local}`;
    const dataBase = DataBaseEnum.HOME_BANNER_LIST;
    const localBD = new DATABASE(dataBase.name)

    const bdItem = await localBD.getItemById(url);
    let response = null;
    if (!bdItem) {
        response = await INTERNAL_API_V2_GET(url);
        try { await localBD.insert(url, [response]) } catch (error) { }
    } else response = bdItem.content;

    return response
}